import {
  KnockOutSheet,
  Filter,
  Selected,
  PreviousResult,
  Dropdowns,
  Team
} from "./types";

import * as OopData from "../../OrderOfPlay/src/types";

export const buildDropdowns = (
  filters: Filter[],
  selected: Selected,
  returnObj = false
) => {
  let finishedDropdowns = buildDropdown(filters, [], selected, returnObj);
  return finishedDropdowns;
};

export const reformatScores = (teams: (Team | OopData.Team)[]) => {
  const scores: PreviousResult["setScore"] = [];
  teams.map((team, teamNumber) => {
    team.scores.map((score, setNumber) => {
      if (teamNumber === 0) {
        scores[setNumber] = {
          scoreA: score,
          scoreB: null
        };
      } else {
        scores[setNumber].scoreB = score;
      }
    });
  });
  return scores;
};

export const getWinnerScore = (teams: (Team | OopData.Team)[]) => {
  const list = reformatScores(teams);
  const winner = list.reduce(
    (list, { scoreA, scoreB }) => {
      if (scoreA && scoreB) {
        if (scoreA.score > scoreB.score) {
          list.A++;
        } else {
          list.B++;
        }
      }
      return list;
    },
    { A: 0, B: 0 }
  );
  list.forEach(item => {
    if (winner.B > winner.A) {
      const A = item.scoreA;
      const B = item.scoreB;
      item.scoreA = B;
      item.scoreB = A;
    }
  });
  return list;
};

export const buildDropdown = (
  filters: Filter[],
  dropdowns: Dropdowns[],
  selected: Selected,
  returnObj = false
) => {
  let dropdown = filters.map(
    (
      { subFilter, dataName, valueCode, valueDesc, ...rest }: Filter,
      index: number
    ) => {
      if (subFilter !== null) {
        if (selected[dataName] === undefined && index === 0) {
          buildDropdown(subFilter, dropdowns, selected, returnObj);
        }
        if (
          selected[dataName] !== undefined &&
          selected[dataName] === valueCode
        ) {
          buildDropdown(subFilter, dropdowns, selected, returnObj);
        }
      }
      const extrafields = returnObj ? rest : undefined;
      return {
        label: valueDesc,
        value: valueCode,
        ...extrafields
      };
    }
  );
  dropdowns.push({
    filterName: filters[0].filterName,
    dataName: filters[0].dataName,
    dropdown
  });
  return dropdowns;
};

export const getPreviousResults = (
  playerId: number,
  rounds: KnockOutSheet[],
  currentRound: number
): PreviousResult[] => {
  const previousResults: PreviousResult[] = [];

  rounds.forEach((round, index) => {
    if (index >= currentRound - 1) {
      return;
    }
    let previousResult: PreviousResult = {
      playStatusCode: "PC",
      playStatusDesc: "",
      resultStatusCode: "DEF",
      resultStatusDesc: "",
      roundDesc: round.roundDesc,
      opponent: [],
      setScore: []
    };

    const match = round.matches.filter(match => {
      // go through both teams and both players using a map
      let isTheMatch = false;
      match.teams.map(team => {
        team.players.map(player => {
          if (player !== null) {
            if (player.playerId === playerId) {
              isTheMatch = true;
            }
          }
        });
      });
      return isTheMatch;
    });

    // once you have the match, get the relevant data and format it
    if (match.length === 1) {
      const matchData = match[0];

      previousResult.playStatusCode = matchData.playStatusCode;
      previousResult.playStatusDesc = matchData.playStatusDesc;
      previousResult.resultStatusCode = matchData.resultStatusCode;
      previousResult.resultStatusDesc = matchData.resultStatusDesc;

      // get the opponent
      let opponent = matchData.teams.filter(team =>
        team.players
          .filter(player => player)
          .every(player => player && player.playerId !== playerId)
      );

      // get name from the opponent
      if (opponent && opponent[0]) {
        opponent[0].players.map(player => {
          if (player !== null) {
            const { hiddenPlayer } = player;
            const playerObj = {
              name: `${player.givenName} ${player.familyName}`,
              profileLink: player.profileLink,
              hiddenPlayer
            };
            previousResult.opponent.push(playerObj);
          }
        });
      }

      // get the score
      let scores: PreviousResult["setScore"] = [];

      matchData.teams.map(team => {
        team.scores.map((score, setNumber) => {
          const { isWinner } = team;
          if (isWinner) {
            scores[setNumber] = {
              scoreA: score,
              scoreB: null
            };
          }
        });
      });

      matchData.teams.map(team => {
        team.scores.map((score, setNumber) => {
          const { isWinner } = team;
          if (!isWinner) {
            scores[setNumber].scoreB = score;
          }
        });
      });

      previousResult.setScore = scores;
      previousResults.push(previousResult);
    }
  });

  return previousResults;
};

export const isOlympics = () => location.pathname.indexOf("lympics") >= 0;
